import { MIMETYPE_MAPPER } from '@/utils/mimeTypeToExtension'

import { GifIcon, JpgIcon, Mp4Icon, PdfIcon, PngIcon, XlsIcon } from './icons'

const FileIcon = ({ mimeType }: { mimeType: string }) => {
  const iconType =
    MIMETYPE_MAPPER[mimeType as keyof typeof MIMETYPE_MAPPER] || [mimeType] ||
    []

  switch (iconType[0]) {
    case 'xls':
      return (
        <div className="flex size-8">
          <XlsIcon className="size-8" />
        </div>
      )
    case 'xlsx':
      return (
        <div className="flex size-8">
          <XlsIcon className="size-8" />
        </div>
      )
    case 'csv':
      return (
        <div className="flex size-8">
          <XlsIcon className="size-8" />
        </div>
      )
    case 'pdf':
      return (
        <div className="flex size-8">
          <PdfIcon className="size-8" />
        </div>
      )
    case 'image/png':
      return (
        <div className="flex size-8">
          <PngIcon className="size-8" />
        </div>
      )
    case 'image/jpg':
      return (
        <div className="flex size-8">
          <JpgIcon className="size-8" />
        </div>
      )
    case 'image/gif':
      return (
        <div className="flex size-8">
          <GifIcon className="size-8" />
        </div>
      )
    case 'mp4':
      return (
        <div className="flex size-8">
          <Mp4Icon className="size-8" />
        </div>
      )
    default:
      return (
        <div className="flex size-8 shrink-0 items-center justify-center rounded bg-red-500/10">
          <span className="text-xs font-medium text-red-500">A</span>
        </div>
      )
  }
}

export { FileIcon }
